(function() { window.GUID_ff73fa31_be3f_477c_93c6_1d429c58287d = { getGuid: function() { return "ff73fa31-be3f-477c-93c6-1d429c58287d"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let SwipeableItemContent;
        (function (SwipeableItemContent) {
            SwipeableItemContent[SwipeableItemContent["Award"] = 0] = "Award";
            SwipeableItemContent[SwipeableItemContent["EventListEventPicture"] = 1] = "EventListEventPicture";
            SwipeableItemContent[SwipeableItemContent["EventWallEventPicture"] = 2] = "EventWallEventPicture";
            SwipeableItemContent[SwipeableItemContent["FollowedPlayerCard"] = 3] = "FollowedPlayerCard";
            SwipeableItemContent[SwipeableItemContent["PlayerCard"] = 4] = "PlayerCard";
            SwipeableItemContent[SwipeableItemContent["ProfilePicture"] = 5] = "ProfilePicture";
            SwipeableItemContent[SwipeableItemContent["TeamCard"] = 6] = "TeamCard";
            SwipeableItemContent[SwipeableItemContent["TeamHeader"] = 7] = "TeamHeader";
            SwipeableItemContent[SwipeableItemContent["TeamMember"] = 8] = "TeamMember";
            SwipeableItemContent[SwipeableItemContent["MatchDetailsOpponent"] = 9] = "MatchDetailsOpponent";
        })(SwipeableItemContent = Enumeration.SwipeableItemContent || (Enumeration.SwipeableItemContent = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=SwipeableItemContent.pre.js.map
